// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Hero ── */
.hero {
  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #0f172a 100%);
  color: var(--white);
  padding: 96px 0 80px;
  overflow: hidden;
}

.hero-inner {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: center;
}

.hero-badge {
  display: inline-block;
  padding: 6px 14px;
  background: rgba(37,99,235,.3);
  border: 1px solid rgba(37,99,235,.5);
  border-radius: 50px;
  font-size: .8rem;
  font-weight: 600;
  color: #93c5fd;
  margin-bottom: 24px;
  letter-spacing: .03em;
}

.hero-title {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  line-height: 1.15;
  margin-bottom: 24px;
  letter-spacing: -.03em;
}

.gradient-text {
  background: linear-gradient(135deg, #60a5fa, #a78bfa);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-subtitle {
  font-size: 1.1rem;
  color: #cbd5e1;
  line-height: 1.7;
  margin-bottom: 40px;
}

.hero-actions {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.hero-actions .btn-outline {
  border-color: rgba(255,255,255,.4);
  color: var(--white);
}
.hero-actions .btn-outline:hover { background: rgba(255,255,255,.1); }

.hero-note {
  font-size: .85rem;
  color: #64748b;
}

/* Hero card mockup */
.hero-visual { perspective: 1000px; }

.hero-card {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: var(--radius);
  overflow: hidden;
  box-shadow: 0 25px 50px rgb(0 0 0 / .4);
  transform: rotateY(-5deg) rotateX(3deg);
}

.hero-card-header {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 16px;
  background: #0f172a;
  border-bottom: 1px solid #334155;
}
.dot { width: 12px; height: 12px; border-radius: 50%; }
.dot.red { background: #ef4444; }
.dot.yellow { background: #f59e0b; }
.dot.green { background: #10b981; }

.hero-card-title {
  margin-left: 8px;
  font-size: .8rem;
  color: #64748b;
}

.hero-card-body { padding: 16px; }

.backup-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 8px;
  margin-bottom: 8px;
  background: rgba(255,255,255,.03);
  border: 1px solid #1e293b;
}
.backup-icon { font-size: 1.1rem; }
.backup-name { font-size: .8rem; color: #e2e8f0; font-weight: 500; }
.backup-meta { font-size: .73rem; color: #64748b; margin-top: 2px; }

.backup-next {
  margin-top: 12px;
  font-size: .8rem;
  color: #64748b;
  padding: 8px 12px;
  border: 1px dashed #334155;
  border-radius: 8px;
  text-align: center;
}
.backup-next strong { color: #93c5fd; }

/* ── Stats bar ── */
.stats-bar {
  background: var(--primary);
  color: var(--white);
  padding: 28px 0;
}

.stats-inner {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  text-align: center;
}

.stat strong { display: block; font-size: 1.5rem; font-weight: 800; }
.stat span { font-size: .85rem; opacity: .85; }

/* ── Sections communes ── */
.section { padding: 96px 0; }

.section-header {
  text-align: center;
  margin-bottom: 64px;
}
.section-header h2 {
  font-size: clamp(1.6rem, 3vw, 2.2rem);
  font-weight: 800;
  letter-spacing: -.02em;
  margin-bottom: 12px;
}
.section-header p { color: var(--text-muted); font-size: 1.05rem; }

/* ── Features ── */
.features { background: var(--surface); }

.features-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}

.feature-plan {
  background: var(--white);
  border: 2px solid var(--border);
  border-radius: var(--radius);
  padding: 40px;
}

.feature-plan-premium {
  border-color: var(--accent);
  box-shadow: 0 0 0 4px rgba(245,158,11,.08), var(--shadow-lg);
}

.feature-plan-header {
  margin-bottom: 28px;
}
.feature-plan-header .badge { margin-bottom: 12px; }
.feature-plan-header h3 { font-size: 1.3rem; font-weight: 700; margin-bottom: 6px; }
.feature-plan-header p { color: var(--text-muted); font-size: .9rem; }

.feature-list { list-style: none; }
.feature-list li {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0;
  border-bottom: 1px solid var(--border);
  font-size: .95rem;
}
.feature-list li:last-child { border-bottom: none; }
.feature-list li.excluded { color: var(--text-muted); text-decoration: line-through; opacity: .6; }

.feature-icon {
  width: 22px; height: 22px;
  display: flex; align-items: center; justify-content: center;
  font-weight: 700; font-size: .85rem;
  flex-shrink: 0;
}
.included .feature-icon { color: var(--success); }
.excluded .feature-icon { color: var(--danger); }

.annual-only {
  margin-left: auto;
  font-size: .75rem;
  background: #fef9c3;
  color: #92400e;
  padding: 2px 8px;
  border-radius: 50px;
  font-weight: 600;
}

/* ── Pricing ── */
.pricing-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 28px;
  align-items: start;
}

.pricing-card {
  background: var(--white);
  border: 2px solid var(--border);
  border-radius: var(--radius);
  padding: 36px 28px;
  position: relative;
}

.pricing-card-popular {
  border-color: var(--accent);
  box-shadow: 0 0 0 4px rgba(245,158,11,.1), var(--shadow-lg);
  transform: translateY(-8px);
}

.popular-badge {
  position: absolute;
  top: -14px; left: 50%;
  transform: translateX(-50%);
  background: var(--accent);
  color: var(--white);
  padding: 4px 16px;
  border-radius: 50px;
  font-size: .78rem;
  font-weight: 700;
  white-space: nowrap;
}

.pricing-plan { font-size: .85rem; font-weight: 600; color: var(--text-muted); text-transform: uppercase; letter-spacing: .05em; margin-bottom: 16px; }

.pricing-price { margin-bottom: 8px; }
.price-amount { font-size: 2.5rem; font-weight: 800; color: var(--text); letter-spacing: -.03em; }
.price-period { font-size: 1rem; color: var(--text-muted); margin-left: 4px; }

.pricing-saving {
  font-size: .82rem;
  color: var(--success);
  font-weight: 600;
  margin-bottom: 24px;
  background: #f0fdf4;
  padding: 4px 10px;
  border-radius: 4px;
  display: inline-block;
}

.pricing-features {
  list-style: none;
  margin-bottom: 28px;
}
.pricing-features li {
  padding: 8px 0;
  font-size: .9rem;
  border-bottom: 1px solid var(--border);
  color: var(--text);
}
.pricing-features li:last-child { border: none; }
.pricing-features li:has(✗) { color: var(--text-muted); }

.pricing-note {
  text-align: center;
  margin-top: 40px;
  color: var(--text-muted);
  font-size: .9rem;
  padding: 16px 24px;
  background: var(--surface);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
}

/* ── How to order ── */
.how-to-order { background: var(--surface); }

.steps {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-bottom: 48px;
}

.step {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  padding: 24px 0;
  border-bottom: 1px solid var(--border);
}
.step:last-child { border-bottom: none; }

.step-num {
  width: 44px; height: 44px;
  border-radius: 50%;
  background: var(--primary);
  color: var(--white);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.1rem;
  font-weight: 800;
  flex-shrink: 0;
}

.step-content h4 { font-size: 1rem; font-weight: 700; margin-bottom: 4px; }
.step-content p { color: var(--text-muted); font-size: .9rem; }

.cheque-info {
  background: var(--white);
  border: 2px solid var(--primary);
  border-radius: var(--radius);
  padding: 32px;
}
.cheque-info h3 { font-size: 1.1rem; font-weight: 700; margin-bottom: 16px; }
.cheque-box p { padding: 8px 0; font-size: .95rem; border-bottom: 1px solid var(--border); }
.cheque-box p:last-child { border: none; }

/* ── FAQ ── */
.faq-list {
  max-width: 800px;
  margin: 0 auto;
}

.faq-item {
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  margin-bottom: 12px;
  overflow: hidden;
}

.faq-item summary {
  padding: 18px 24px;
  font-weight: 600;
  cursor: pointer;
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: var(--white);
}
.faq-item summary::-webkit-details-marker { display: none; }
.faq-item summary::after { content: '+'; font-size: 1.2rem; color: var(--primary); }
.faq-item[open] summary::after { content: '−'; }
.faq-item[open] summary { background: var(--primary-light); color: var(--primary); }

.faq-item p {
  padding: 16px 24px;
  color: var(--text-muted);
  font-size: .95rem;
  line-height: 1.7;
  border-top: 1px solid var(--border);
}

/* ── CTA final ── */
.cta-section {
  background: linear-gradient(135deg, #1e40af 0%, #7c3aed 100%);
  padding: 96px 0;
  color: var(--white);
  text-align: center;
}

.cta-inner h2 { font-size: clamp(1.6rem, 3vw, 2.2rem); font-weight: 800; margin-bottom: 16px; }
.cta-inner p { font-size: 1.1rem; opacity: .85; margin-bottom: 40px; }

.cta-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
}

/* ── Responsive ── */
@media (max-width: 1024px) {
  .hero-inner { grid-template-columns: 1fr; }
  .hero-visual { display: none; }
  .pricing-grid { grid-template-columns: 1fr; }
  .pricing-card-popular { transform: none; }
  .stats-inner { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 768px) {
  .hero { padding: 64px 0; }
  .section { padding: 64px 0; }
  .features-grid { grid-template-columns: 1fr; }
  .stats-inner { grid-template-columns: repeat(2, 1fr); }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Landing.css"],"names":[],"mappings":"AAAA,eAAe;AACf;EACE,0EAA0E;EAC1E,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,8BAA8B;EAC9B,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;EACrD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;AACA,mCAAmC,gCAAgC,EAAE;;AAErE;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA,qBAAqB;AACrB,eAAe,mBAAmB,EAAE;;AAEpC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;AACA,OAAO,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;AACtD,WAAW,mBAAmB,EAAE;AAChC,cAAc,mBAAmB,EAAE;AACnC,aAAa,mBAAmB,EAAE;;AAElC;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB,aAAa,EAAE;;AAEjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,yBAAyB;AAC3B;AACA,eAAe,iBAAiB,EAAE;AAClC,eAAe,gBAAgB,EAAE,cAAc,EAAE,gBAAgB,EAAE;AACnE,eAAe,iBAAiB,EAAE,cAAc,EAAE,eAAe,EAAE;;AAEnE;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;AACpB;AACA,sBAAsB,cAAc,EAAE;;AAEtC,oBAAoB;AACpB;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA,eAAe,cAAc,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AACpE,aAAa,iBAAiB,EAAE,YAAY,EAAE;;AAE9C,4BAA4B;AAC5B,WAAW,eAAe,EAAE;;AAE5B;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA,oBAAoB,wBAAwB,EAAE,kBAAkB,EAAE;;AAElE,mBAAmB;AACnB,YAAY,0BAA0B,EAAE;;AAExC;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;AACrB;AACA,8BAA8B,mBAAmB,EAAE;AACnD,0BAA0B,iBAAiB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AACnF,yBAAyB,wBAAwB,EAAE,gBAAgB,EAAE;;AAErE,gBAAgB,gBAAgB,EAAE;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,sCAAsC;EACtC,iBAAiB;AACnB;AACA,8BAA8B,mBAAmB,EAAE;AACnD,4BAA4B,wBAAwB,EAAE,6BAA6B,EAAE,WAAW,EAAE;;AAElG;EACE,WAAW,EAAE,YAAY;EACzB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,gBAAgB,EAAE,iBAAiB;EACnC,cAAc;AAChB;AACA,0BAA0B,qBAAqB,EAAE;AACjD,0BAA0B,oBAAoB,EAAE;;AAEhD;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,2DAA2D;EAC3D,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU,EAAE,SAAS;EACrB,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,gBAAgB,iBAAiB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,mBAAmB,EAAE;;AAEtJ,iBAAiB,kBAAkB,EAAE;AACrC,gBAAgB,iBAAiB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,sBAAsB,EAAE;AACjG,gBAAgB,eAAe,EAAE,wBAAwB,EAAE,gBAAgB,EAAE;;AAE7E;EACE,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;AACpB;AACA,kCAAkC,YAAY,EAAE;AAChD,8BAA8B,wBAAwB,EAAE;;AAExD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;AACjC;;AAEA,uBAAuB;AACvB,gBAAgB,0BAA0B,EAAE;;AAE5C;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;AACA,mBAAmB,mBAAmB,EAAE;;AAExC;EACE,WAAW,EAAE,YAAY;EACzB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa,EAAE,mBAAmB,EAAE,uBAAuB;EAC3D,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC1E,kBAAkB,wBAAwB,EAAE,gBAAgB,EAAE;;AAE9D;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,aAAa;AACf;AACA,kBAAkB,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC5E,gBAAgB,cAAc,EAAE,iBAAiB,EAAE,sCAAsC,EAAE;AAC3F,2BAA2B,YAAY,EAAE;;AAEzC,cAAc;AACd;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;AAC1B;AACA,4CAA4C,aAAa,EAAE;AAC3D,2BAA2B,YAAY,EAAE,iBAAiB,EAAE,qBAAqB,EAAE;AACnF,iCAAiC,YAAY,EAAE;AAC/C,0BAA0B,gCAAgC,EAAE,qBAAqB,EAAE;;AAEnF;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,oBAAoB;AACpB;EACE,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,gBAAgB,qCAAqC,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;AAC9F,eAAe,iBAAiB,EAAE,YAAY,EAAE,mBAAmB,EAAE;;AAErE;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,cAAc,0BAA0B,EAAE;EAC1C,eAAe,aAAa,EAAE;EAC9B,gBAAgB,0BAA0B,EAAE;EAC5C,wBAAwB,eAAe,EAAE;EACzC,eAAe,qCAAqC,EAAE;AACxD;;AAEA;EACE,QAAQ,eAAe,EAAE;EACzB,WAAW,eAAe,EAAE;EAC5B,iBAAiB,0BAA0B,EAAE;EAC7C,eAAe,qCAAqC,EAAE;AACxD","sourcesContent":["/* ── Hero ── */\n.hero {\n  background: linear-gradient(135deg, #0f172a 0%, #1e3a8a 50%, #0f172a 100%);\n  color: var(--white);\n  padding: 96px 0 80px;\n  overflow: hidden;\n}\n\n.hero-inner {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 64px;\n  align-items: center;\n}\n\n.hero-badge {\n  display: inline-block;\n  padding: 6px 14px;\n  background: rgba(37,99,235,.3);\n  border: 1px solid rgba(37,99,235,.5);\n  border-radius: 50px;\n  font-size: .8rem;\n  font-weight: 600;\n  color: #93c5fd;\n  margin-bottom: 24px;\n  letter-spacing: .03em;\n}\n\n.hero-title {\n  font-size: clamp(2rem, 4vw, 3rem);\n  font-weight: 800;\n  line-height: 1.15;\n  margin-bottom: 24px;\n  letter-spacing: -.03em;\n}\n\n.gradient-text {\n  background: linear-gradient(135deg, #60a5fa, #a78bfa);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.hero-subtitle {\n  font-size: 1.1rem;\n  color: #cbd5e1;\n  line-height: 1.7;\n  margin-bottom: 40px;\n}\n\n.hero-actions {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.hero-actions .btn-outline {\n  border-color: rgba(255,255,255,.4);\n  color: var(--white);\n}\n.hero-actions .btn-outline:hover { background: rgba(255,255,255,.1); }\n\n.hero-note {\n  font-size: .85rem;\n  color: #64748b;\n}\n\n/* Hero card mockup */\n.hero-visual { perspective: 1000px; }\n\n.hero-card {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: var(--radius);\n  overflow: hidden;\n  box-shadow: 0 25px 50px rgb(0 0 0 / .4);\n  transform: rotateY(-5deg) rotateX(3deg);\n}\n\n.hero-card-header {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 12px 16px;\n  background: #0f172a;\n  border-bottom: 1px solid #334155;\n}\n.dot { width: 12px; height: 12px; border-radius: 50%; }\n.dot.red { background: #ef4444; }\n.dot.yellow { background: #f59e0b; }\n.dot.green { background: #10b981; }\n\n.hero-card-title {\n  margin-left: 8px;\n  font-size: .8rem;\n  color: #64748b;\n}\n\n.hero-card-body { padding: 16px; }\n\n.backup-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  margin-bottom: 8px;\n  background: rgba(255,255,255,.03);\n  border: 1px solid #1e293b;\n}\n.backup-icon { font-size: 1.1rem; }\n.backup-name { font-size: .8rem; color: #e2e8f0; font-weight: 500; }\n.backup-meta { font-size: .73rem; color: #64748b; margin-top: 2px; }\n\n.backup-next {\n  margin-top: 12px;\n  font-size: .8rem;\n  color: #64748b;\n  padding: 8px 12px;\n  border: 1px dashed #334155;\n  border-radius: 8px;\n  text-align: center;\n}\n.backup-next strong { color: #93c5fd; }\n\n/* ── Stats bar ── */\n.stats-bar {\n  background: var(--primary);\n  color: var(--white);\n  padding: 28px 0;\n}\n\n.stats-inner {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 16px;\n  text-align: center;\n}\n\n.stat strong { display: block; font-size: 1.5rem; font-weight: 800; }\n.stat span { font-size: .85rem; opacity: .85; }\n\n/* ── Sections communes ── */\n.section { padding: 96px 0; }\n\n.section-header {\n  text-align: center;\n  margin-bottom: 64px;\n}\n.section-header h2 {\n  font-size: clamp(1.6rem, 3vw, 2.2rem);\n  font-weight: 800;\n  letter-spacing: -.02em;\n  margin-bottom: 12px;\n}\n.section-header p { color: var(--text-muted); font-size: 1.05rem; }\n\n/* ── Features ── */\n.features { background: var(--surface); }\n\n.features-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 32px;\n}\n\n.feature-plan {\n  background: var(--white);\n  border: 2px solid var(--border);\n  border-radius: var(--radius);\n  padding: 40px;\n}\n\n.feature-plan-premium {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 4px rgba(245,158,11,.08), var(--shadow-lg);\n}\n\n.feature-plan-header {\n  margin-bottom: 28px;\n}\n.feature-plan-header .badge { margin-bottom: 12px; }\n.feature-plan-header h3 { font-size: 1.3rem; font-weight: 700; margin-bottom: 6px; }\n.feature-plan-header p { color: var(--text-muted); font-size: .9rem; }\n\n.feature-list { list-style: none; }\n.feature-list li {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 0;\n  border-bottom: 1px solid var(--border);\n  font-size: .95rem;\n}\n.feature-list li:last-child { border-bottom: none; }\n.feature-list li.excluded { color: var(--text-muted); text-decoration: line-through; opacity: .6; }\n\n.feature-icon {\n  width: 22px; height: 22px;\n  display: flex; align-items: center; justify-content: center;\n  font-weight: 700; font-size: .85rem;\n  flex-shrink: 0;\n}\n.included .feature-icon { color: var(--success); }\n.excluded .feature-icon { color: var(--danger); }\n\n.annual-only {\n  margin-left: auto;\n  font-size: .75rem;\n  background: #fef9c3;\n  color: #92400e;\n  padding: 2px 8px;\n  border-radius: 50px;\n  font-weight: 600;\n}\n\n/* ── Pricing ── */\n.pricing-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 28px;\n  align-items: start;\n}\n\n.pricing-card {\n  background: var(--white);\n  border: 2px solid var(--border);\n  border-radius: var(--radius);\n  padding: 36px 28px;\n  position: relative;\n}\n\n.pricing-card-popular {\n  border-color: var(--accent);\n  box-shadow: 0 0 0 4px rgba(245,158,11,.1), var(--shadow-lg);\n  transform: translateY(-8px);\n}\n\n.popular-badge {\n  position: absolute;\n  top: -14px; left: 50%;\n  transform: translateX(-50%);\n  background: var(--accent);\n  color: var(--white);\n  padding: 4px 16px;\n  border-radius: 50px;\n  font-size: .78rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.pricing-plan { font-size: .85rem; font-weight: 600; color: var(--text-muted); text-transform: uppercase; letter-spacing: .05em; margin-bottom: 16px; }\n\n.pricing-price { margin-bottom: 8px; }\n.price-amount { font-size: 2.5rem; font-weight: 800; color: var(--text); letter-spacing: -.03em; }\n.price-period { font-size: 1rem; color: var(--text-muted); margin-left: 4px; }\n\n.pricing-saving {\n  font-size: .82rem;\n  color: var(--success);\n  font-weight: 600;\n  margin-bottom: 24px;\n  background: #f0fdf4;\n  padding: 4px 10px;\n  border-radius: 4px;\n  display: inline-block;\n}\n\n.pricing-features {\n  list-style: none;\n  margin-bottom: 28px;\n}\n.pricing-features li {\n  padding: 8px 0;\n  font-size: .9rem;\n  border-bottom: 1px solid var(--border);\n  color: var(--text);\n}\n.pricing-features li:last-child { border: none; }\n.pricing-features li:has(✗) { color: var(--text-muted); }\n\n.pricing-note {\n  text-align: center;\n  margin-top: 40px;\n  color: var(--text-muted);\n  font-size: .9rem;\n  padding: 16px 24px;\n  background: var(--surface);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border);\n}\n\n/* ── How to order ── */\n.how-to-order { background: var(--surface); }\n\n.steps {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  margin-bottom: 48px;\n}\n\n.step {\n  display: flex;\n  gap: 24px;\n  align-items: flex-start;\n  padding: 24px 0;\n  border-bottom: 1px solid var(--border);\n}\n.step:last-child { border-bottom: none; }\n\n.step-num {\n  width: 44px; height: 44px;\n  border-radius: 50%;\n  background: var(--primary);\n  color: var(--white);\n  display: flex; align-items: center; justify-content: center;\n  font-size: 1.1rem;\n  font-weight: 800;\n  flex-shrink: 0;\n}\n\n.step-content h4 { font-size: 1rem; font-weight: 700; margin-bottom: 4px; }\n.step-content p { color: var(--text-muted); font-size: .9rem; }\n\n.cheque-info {\n  background: var(--white);\n  border: 2px solid var(--primary);\n  border-radius: var(--radius);\n  padding: 32px;\n}\n.cheque-info h3 { font-size: 1.1rem; font-weight: 700; margin-bottom: 16px; }\n.cheque-box p { padding: 8px 0; font-size: .95rem; border-bottom: 1px solid var(--border); }\n.cheque-box p:last-child { border: none; }\n\n/* ── FAQ ── */\n.faq-list {\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.faq-item {\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  margin-bottom: 12px;\n  overflow: hidden;\n}\n\n.faq-item summary {\n  padding: 18px 24px;\n  font-weight: 600;\n  cursor: pointer;\n  list-style: none;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: var(--white);\n}\n.faq-item summary::-webkit-details-marker { display: none; }\n.faq-item summary::after { content: '+'; font-size: 1.2rem; color: var(--primary); }\n.faq-item[open] summary::after { content: '−'; }\n.faq-item[open] summary { background: var(--primary-light); color: var(--primary); }\n\n.faq-item p {\n  padding: 16px 24px;\n  color: var(--text-muted);\n  font-size: .95rem;\n  line-height: 1.7;\n  border-top: 1px solid var(--border);\n}\n\n/* ── CTA final ── */\n.cta-section {\n  background: linear-gradient(135deg, #1e40af 0%, #7c3aed 100%);\n  padding: 96px 0;\n  color: var(--white);\n  text-align: center;\n}\n\n.cta-inner h2 { font-size: clamp(1.6rem, 3vw, 2.2rem); font-weight: 800; margin-bottom: 16px; }\n.cta-inner p { font-size: 1.1rem; opacity: .85; margin-bottom: 40px; }\n\n.cta-actions {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n/* ── Responsive ── */\n@media (max-width: 1024px) {\n  .hero-inner { grid-template-columns: 1fr; }\n  .hero-visual { display: none; }\n  .pricing-grid { grid-template-columns: 1fr; }\n  .pricing-card-popular { transform: none; }\n  .stats-inner { grid-template-columns: repeat(2, 1fr); }\n}\n\n@media (max-width: 768px) {\n  .hero { padding: 64px 0; }\n  .section { padding: 64px 0; }\n  .features-grid { grid-template-columns: 1fr; }\n  .stats-inner { grid-template-columns: repeat(2, 1fr); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
